import {
  Divider,
  List,
  ListItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Grid } from "@mui/system";

export const IttechCustomJoins3 = () => {
  return (
    <>
      <Grid container spacing={5} alignItems="center">
        <Grid size={6}>
          <Typography variant="h4">User</Typography>
          <Table
            size="medium"
            sx={{
              mb: 4,
              th: {
                fontWeight: "bold",
                borderRight: "1px solid #000",
                fontSize: "2.2em",
                background: "#ddd",
              },

              td: {
                borderRight: "1px solid #000",
                fontSize: "2em",
              },
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Naam</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>1</TableCell>
                <TableCell>Leander</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>2</TableCell>
                <TableCell>Roland</TableCell>
              </TableRow>
            </TableBody>
          </Table>

          <Typography variant="h4">Playlist</Typography>
          <Table
            size="medium"
            sx={{
              mb: 4,
              th: {
                fontWeight: "bold",
                borderRight: "1px solid #000",
                fontSize: "2.2em",
                background: "#ddd",
              },

              td: {
                borderRight: "1px solid #000",
                fontSize: "2em",
              },
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Naam</TableCell>
                <TableCell>User_id</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>1</TableCell>
                <TableCell>Favorietjes ⭐️</TableCell>
                <TableCell>1</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>2</TableCell>
                <TableCell>Chill 🧘</TableCell>
                <TableCell>2</TableCell>
              </TableRow>
            </TableBody>
          </Table>

          <Typography variant="h4">Playlist Song Koppeling</Typography>
          <Table
            size="medium"
            sx={{
              th: {
                fontWeight: "bold",
                borderRight: "1px solid #000",
                fontSize: "2.2em",
                background: "#ddd",
              },

              td: {
                borderRight: "1px solid #000",
                fontSize: "2em",
              },
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Playlist_id</TableCell>
                <TableCell>Song_id</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>1</TableCell>
                <TableCell>1</TableCell>
                <TableCell>5</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>2</TableCell>
                <TableCell>2</TableCell>
                <TableCell>4</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>3</TableCell>
                <TableCell>2</TableCell>
                <TableCell>9</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Grid>

        <Grid size={6}>
          <List sx={{ fontSize: "2.2em" }}>
            <ListItem sx={{ fontWeight: "bold" }}>
              - Wat als ik ook nog een user_id en playlist_id zou toevoegen in
              één enkele tabel?
            </ListItem>
            <ListItem>
              <Table
                size="medium"
                sx={{
                  th: {
                    fontWeight: "bold",
                    borderRight: "1px solid #000",
                    fontSize: "0.7em",
                    background: "#ddd",
                  },

                  td: {
                    borderRight: "1px solid #000",
                    fontSize: "0.7em",
                  },
                }}
              >
                <TableHead>
                  <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>Artiest</TableCell>
                    <TableCell>Album</TableCell>
                    <TableCell>Song</TableCell>
                    <TableCell>playlist_id</TableCell>
                    <TableCell>user_id</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>1</TableCell>
                    <TableCell>Queen</TableCell>
                    <TableCell>A Night at the Opera</TableCell>
                    <TableCell>Bohemian Rhapsody</TableCell>
                    <TableCell>1</TableCell>
                    <TableCell>4</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>2</TableCell>
                    <TableCell>Queen</TableCell>
                    <TableCell>A Night at the Opera</TableCell>
                    <TableCell>Love of my Live</TableCell>
                    <TableCell>2</TableCell>
                    <TableCell>10</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>3</TableCell>
                    <TableCell>Queen</TableCell>
                    <TableCell>A Night at the Opera</TableCell>
                    <TableCell>You're my best Friend</TableCell>
                    <TableCell>3</TableCell>
                    <TableCell>13</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </ListItem>
            <ListItem sx={{ pl: 10, mt: 2 }}>
              - Dit zou leiden tot miljarden records in één tabel!
            </ListItem>
          </List>

          <Divider />

          <List sx={{ fontSize: "2.2em" }}>
            <ListItem sx={{ fontWeight: "bold" }}>INNER JOIN</ListItem>
          </List>

          <Typography
            variant="caption"
            sx={{ fontSize: "1.4em", fontWeight: "bold", textAlign: "left" }}
          >
            SELECT playlist.naam AS playlist_naam, user.naam AS gebruiker_naam
            <br /> FROM playlist <br /> INNER JOIN user ON playlist.user_id =
            user.id;
          </Typography>

          <Table
            size="medium"
            sx={{
              mb: 2,
              th: {
                fontWeight: "bold",
                borderRight: "1px solid #000",
                fontSize: "1.6em",
                background: "#ddd",
              },

              td: {
                borderRight: "1px solid #000",
                fontSize: "1.6em",
              },
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell>playlist_naam</TableCell>
                <TableCell>gebruiker_naam</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>Favorietjes ⭐️</TableCell>
                <TableCell>Leander</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Chill 🧘</TableCell>
                <TableCell>Roland</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Grid>
      </Grid>
    </>
  );
};
